<template>
  <div data-testid="chat-suggestions" class="suggestions-peek" :class="{ 'is-open': isVisible }">
    <div data-testid="chat-suggestions__toggle" class="peek-toggle" @click="togglePeek">
      <img 
        data-testid="chat-suggestions__toggle-icon"
        :src="isVisible ? '/img/icons/agentic/arrow-right-double.svg' : '/img/icons/agentic/arrow-left-double.svg'" 
        alt="Toggle suggestions"
        class="toggle-icon"
      />
    </div>
    <div data-testid="chat-suggestions__panel" class="peek-panel">
      <!-- <div data-testid="chat-suggestions__header" class="suggestions-header">
        <span data-testid="chat-suggestions__header-title">{{ CHAT_SUGGESTIONS_UI.HEADER_TITLE }}</span>
      </div> -->
      <div data-testid="chat-suggestions__content" class="suggestions-content">
        <!-- Detail View -->
        <div v-if="selectedSuggestionDetail" data-testid="chat-suggestions__detail-view" class="detail-view">
          <div data-testid="chat-suggestions__detail-header" class="detail-header">
            <button
              data-testid="chat-suggestions__back-button"
              class="back-button"
              @click="closeDetail"
            >
              <img src="/img/icons/agentic/arrow-left.svg" alt="Back" class="back-icon" />
              Back
            </button>
          </div>
          <div data-testid="chat-suggestions__detail-content" class="detail-content">
            <h3 data-testid="chat-suggestions__detail-title" class="detail-title">{{ selectedSuggestionDetail.title }}</h3>

            <div data-testid="chat-suggestions__detail-section" class="detail-section">
              <h4 data-testid="chat-suggestions__detail-section-title">Description</h4>
              <p data-testid="chat-suggestions__detail-description">{{ selectedSuggestionDetail.description }}</p>
            </div>

            <div data-testid="chat-suggestions__detail-section" class="detail-section">
              <h4 data-testid="chat-suggestions__detail-section-title">Parameters</h4>
              <p data-testid="chat-suggestions__detail-parameters">{{ selectedSuggestionDetail.parametersDescription }}</p>
            </div>

            <div data-testid="chat-suggestions__detail-section" class="detail-section">
              <h4 data-testid="chat-suggestions__detail-section-title">Examples</h4>
              <ul data-testid="chat-suggestions__detail-examples" class="detail-examples">
                <li
                  v-for="(example, idx) in selectedSuggestionDetail.examples"
                  :key="idx"
                  data-testid="chat-suggestions__detail-example"
                >
                  {{ example }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- List View -->
        <div v-else>
          <!-- Selected Context Section -->
          <!-- <div data-testid="chat-suggestions__context-section" class="suggestions-section">
            <div data-testid="chat-suggestions__context-heading" class="suggestions-section-heading">Selected Context</div>
            <chat-context-selector data-testid="chat-suggestions__context-selector" />
          </div> -->

          <!-- Suggested Prompts Section -->
          <div data-testid="chat-suggestions__prompts-section" class="suggestions-section">
            <div data-testid="chat-suggestions__prompts-heading" class="suggestions-section-heading">Suggested Prompts</div>
            <div v-if="suggestions.length > 0" class="d-flex flex-column gap-3">
              <div
                v-for="(suggestion, index) in suggestions"
                :key="index"
                data-testid="chat-suggestions__item"
                class="suggestion-item"
              >
                <div
                  data-testid="chat-suggestions__item-content"
                  class="suggestion-content-area"
                  @click="selectSuggestion(suggestion)"
                >
                  <div data-testid="chat-suggestions__item-title" class="suggestion-title">{{ suggestion.title }}</div>
                  <div data-testid="chat-suggestions__item-subtitle" class="suggestion-subtitle">{{ suggestion.prompt }}</div>
                </div>
                <!-- TODO: Uncomment later - suggestion will apply for the entire card -->
                <!-- <div
                  data-testid="chat-suggestions__item-info-button"
                  class="suggestion-info-button"
                  @click.stop="showDetail(suggestion)"
                >
                  <img src="/img/icons/agentic/arrow-right.svg" alt="More info" class="info-icon" />
                </div> -->
              </div>
            </div>
            <div v-else data-testid="chat-suggestions__empty-state" class="no-suggestions">
              {{ CHAT_SUGGESTIONS_UI.NO_SUGGESTIONS_MESSAGE }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHAT_SUGGESTIONS_UI } from '../utils/constants';
// import ChatContextSelector from './ChatContextSelector.vue';

export default {
  name: CHAT_SUGGESTIONS_UI.COMPONENT_NAME,
  components: {
    // ChatContextSelector
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    suggestions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      CHAT_SUGGESTIONS_UI,
      selectedSuggestionDetail: null
    };
  },
  methods: {
    togglePeek() {
      if (this.isVisible) {
        this.$emit('close');
      } else {
        this.$emit('open');
      }
    },
    close() {
      this.$emit('close');
    },
    selectSuggestion(suggestion) {
      this.$emit('select', suggestion);
    },
    showDetail(suggestion) {
      this.selectedSuggestionDetail = suggestion;
    },
    closeDetail() {
      this.selectedSuggestionDetail = null;
    }
  },
  beforeDestroy() {
    this.selectedSuggestionDetail = null;
  }
}
</script>

<style scoped>
@import '../styles/ChatSuggestions.css';
</style>